<template>
    <div class="task-time">
        <div class="task-time__items">
            <div
                    v-for="(item, key) in items"
                    class="task-time__item">
                <div
                        class="task-time__item-label"
                        @click="edit(key)"
                >{{ getLabel(item) }}</div>
                <div class="task-time__item-actions">
                    <v-btn fab small color="primary" @click="remove(key)" class="btn-fab-small ml-1" elevation="0">
                        <v-icon>mdi-close</v-icon>
                    </v-btn>
                </div>
            </div>
        </div>
        <time-form
          :project-id="projectId"
          :task-id="taskId"
          :types="types"
          @created="addItem($event)"
          @updated="updated($event)"
          ref="timeForm"
        ></time-form>
    </div>
</template>

<script>
    import TimeForm from './Form';
    import { format } from 'date-fns';
    import PopupHeader from "../../../ui/PopupHeader";

    export default {
        components: {TimeForm, PopupHeader},
        props: {
            projectId: null,
            taskId: null,
            countItems: Number
        },
        data() {
            return {
                items: [],
                item: {},
                loading: [],
                types: [],
                typesLoading: false,
                localCountItems: this.countItems
            }
        },
        watch: {
            items(v) {
                this.localCountItems = v.length;
            },
            localCountItems(v) {
                this.$emit('update:countItems', this.localCountItems);
            },
            taskId() {
                this.loadTimes();
            }
        },
        methods: {
            getLabel(item) {
                return this.$t('timeType.'+item.type) +
                        (item.type === 'one' ? ', ' + this.dateString(item._date) : '') +
                        (item.type === 'every_year' ? ', ' + this.$t('month.'+item.month_of_year) : '') +
                        (item.type === 'every_week' ? ', ' + this.$t('dayOfWeek.'+item.day_of_week) : '') +
                        (item.type === 'every_month' || item.type === 'every_year' ? ', ' + item.day_of_month : '') +
                        ', ' + item._time;
            },
            loadTimes() {
                this.loading = true;

                if (this.taskId === null || this.taskId === undefined) return;

                this.$store.dispatch('loadTimes', {id: this.projectId, subId: this.taskId})
                    .then(res => {
                        this.items = res;

                        this.items.forEach((item, key) => {
                            let date = this.timeServerToLocal(item.time);
                            this.items[key]._date = format(date, 'yyyy-MM-dd');
                            this.items[key]._time = format(date, 'HH:mm');
                        });
                    })
                    .finally(() => this.loading = false);
            },
            add() {
                this.$refs.timeForm.create();
            },
            loadTypes() {
                this.typesLoading = true;
                this.$store.dispatch('loadTimeTypes')
                    .then(res => this.types = res)
                    .finally(() => this.typesLoading = false);
            },
            addItem(item) {
                this.items.push(item);
            },
            updated(model) {
              let i = this.items.map(v => v.id).indexOf(model.id);
              if (i > -1) {
                this.items[i].id = model.id;
                this.items[i].time = model.time;
                this.items[i].day_of_month = model.day_of_month;
                this.items[i].day_of_week = model.day_of_week;
                this.items[i].month_of_year = model.month_of_year;
                this.items[i].type = model.type;
                this.items[i]._date = model._date;
                this.items[i]._time = model._time;
              }
            },
            remove(index) {
                if (!confirm(this.$t('msg.remove')+'?')) return;

                let item = this.items[index];

                this.$store.dispatch('deleteTime', {
                    id: this.projectId,
                    subId: this.taskId,
                    subSubId: item.id
                })
                    .then(() => {
                        this.items.splice(index, 1);
                    });
            },
            edit(index) {
                this.$refs.timeForm.open(this.items[index]);
            }
        },
        created() {
            this.loadTypes();
            this.loadTimes();
        }
    }
</script>

<style lang="scss">
    .task-time {}
    .task-time__items {
        border-bottom: 1px solid #fff;
    }
    .task-time__item {
        height: 31px;
        display: flex;
        border-top: 1px solid #fff;
        align-items: center;
        justify-content: space-between;
    }
    .task-time__item-label {
        color: #000;
        cursor: pointer;

        &:hover {
            text-decoration: underline;
        }
    }
</style>